module.exports = __webpack_public_path__ + "static/img/应用效果1-盲区大.7cf47f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2/应用效果1-盲区大.png
// module id = fwTY
// module chunks = 0